import {
  AnimationEvent,
  animate,
  state,
  style,
  transition,
  trigger
} from "@angular/animations";
import {
  Component,
  EventEmitter,
  HostBinding,
  HostListener
} from "@angular/core";

import {GrowlNotice} from "../../../core/utils/growl-service/growl-notice";

@Component({
  templateUrl: "./growl-container.component.html",
  animations: [
    trigger("flyInOut", [
      state(
        "",
        style({
          height: "*",
          opacity: 1
        })
      ),
      transition("void => *", [
        style({
          height: 0,
          opacity: 0
        }),
        animate(200)
      ]),
      transition("* => void", [
        animate(
          200,
          style({
            height: "*",
            opacity: 0
          })
        ),
        animate(
          100,
          style({
            height: 0
          })
        )
      ])
    ])
  ]
})
export class GrowlContainerComponent {
  notices: GrowlNotice[] = [];
  noticesEmptied: EventEmitter<void> = new EventEmitter<void>();

  @HostBinding("class.growl-container")
  get hostClass(): boolean {
    return true;
  }

  @HostListener("document:keydown.escape")
  handleEscape(): void {
    this.notices.shift();
  }

  addNotice(notice: GrowlNotice): void {
    // shallow dupe in case user passes same object to open separate notices.
    this.notices.push({ ...notice });
  }

  removeNotice(notice: GrowlNotice): void {
    const noticeIdx = this.notices.indexOf(notice);
    if (!~noticeIdx) {
      return;
    }
    this.notices.splice(noticeIdx, 1);
  }

  /*
   * `noticesCount` includes notices which are removed, but still finishing their exit animation.
   * By checking noticesCount, we wait to remove the GrowlContainer after all notices have exited.
   */
  private noticesCount: number = 0;
  noticeAnimationStarted(event: AnimationEvent): void {
    if (event.fromState === "void" && event.toState !== "void") {
      this.noticesCount++;
    }
  }

  noticeAnimationDone(event: AnimationEvent): void {
    if (event.toState === "void") {
      this.noticesCount--;

      if (this.noticesCount === 0) {
        this.noticesEmptied.emit();
      }
    }
  }
}
